import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'react-router-redux';
import { createHashHistory } from 'history';
import rootReducer from './reducers';

// custom logger middleware
const loggerMiddleware = (store: any) => (next: any) => (action: any) => {
  const result = next(action);
  //console.log('State after:', store.getState());
  return result;
};

export const history: any = createHashHistory();

const initialState = {}; // optional, you can omit if reducers have their own defaults

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState as any,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      routerMiddleware(history),
      loggerMiddleware
    ),
  devTools: true,
});

export default store;